import { j as e } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { T as g, P as j, R as N, C as f, F as v, a as x, b as p, D as u, O as h } from "../../chunks/X24.CNnx-_EL.js";
import { c } from "../../chunks/index.C4-GUKyp.js";
import * as r from "react";
import { B as S } from "../../chunks/Button.Ccj-dDdM.js";
import { c as d } from "../../chunks/index.CxSWpsOB.js";
function H(t) {
  return /* @__PURE__ */ e.jsx(N, { "data-slot": "sheet", ...t });
}
const W = g, R = j, y = r.forwardRef(({
  headerAlignment: t,
  className: a,
  ...s
}, o) => /* @__PURE__ */ e.jsx(f, { ref: o, asChild: !0, ...s, children: /* @__PURE__ */ e.jsxs(S, { variant: "text-only", className: d({
  "tw-absolute tw-right-16 md:tw-right-24 tw-top-16 md:tw-top-24": t === "center",
  "tw-ml-64": t !== "center"
}, a), children: [
  /* @__PURE__ */ e.jsx(v, {}),
  /* @__PURE__ */ e.jsx("span", { className: "tw-sr-only", children: "Close" })
] }) }));
y.displayName = f.displayName;
const b = r.forwardRef(({
  className: t,
  animate: a = !0,
  ...s
}, o) => /* @__PURE__ */ e.jsx(h, { ref: o, "data-slot": "sheet-overlay", className: d("tw-fixed tw-inset-0 tw-z-[9997] tw-bg-gray-900/80", a && "data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-fade-out-0", t), ...s }));
b.displayName = h.displayName;
const C = c(["tw-fixed tw-z-[9998]", "max-md:tw-inset-x-0 max-md:tw-top-[32px] max-md:tw-bottom-0", "max-md:tw-mx-auto max-md:tw-w-full max-md:tw-max-w-[480px]"].join(" "), {
  variants: {
    side: {
      right: "md:tw-inset-y-0 md:tw-right-0  md:tw-w-[480px]",
      left: "md:tw-inset-y-0 md:tw-left-0   md:tw-w-[480px]",
      top: "md:tw-inset-x-0 md:tw-top-0    md:tw-w-screen",
      bottom: "md:tw-inset-x-0 md:tw-bottom-0 md:tw-w-screen"
    }
  },
  defaultVariants: {
    side: "right"
  }
}), T = c(["tw-bg-base-white tw-shadow-lg tw-outline-none tw-flex tw-flex-col tw-min-h-0", "max-md:tw-h-full max-md:tw-overflow-hidden", "max-md:tw-border-t max-md:tw-border-gray-300 max-md:tw-rounded-t-4", "max-md:data-[state=open]:tw-slide-in-from-bottom max-md:data-[state=closed]:tw-slide-out-to-bottom", "max-md:data-[state=open]:tw-zoom-in-95 max-md:data-[state=closed]:tw-zoom-out-95"].join(" "), {
  variants: {
    side: {
      right: "md:tw-h-screen md:tw-border-l md:tw-border-gray-300 md:data-[state=open]:tw-slide-in-from-right md:data-[state=closed]:tw-slide-out-to-right",
      left: "md:tw-h-screen md:tw-border-r md:tw-border-gray-300 md:data-[state=open]:tw-slide-in-from-left md:data-[state=closed]:tw-slide-out-to-left",
      top: "md:tw-border-b md:tw-border-gray-300 md:data-[state=open]:tw-slide-in-from-top md:data-[state=closed]:tw-slide-out-to-top",
      bottom: "md:tw-border-t md:tw-border-gray-300 md:data-[state=open]:tw-slide-in-from-bottom md:data-[state=closed]:tw-slide-out-to-bottom"
    },
    animate: {
      true: ["data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out", "data-[state=open]:tw-duration-500 data-[state=closed]:tw-duration-300 tw-ease-in-out"].join(" "),
      false: ""
    }
  },
  defaultVariants: {
    side: "right",
    animate: !0
  }
}), B = r.forwardRef(({
  side: t = "right",
  animate: a = !0,
  className: s,
  children: o,
  ...m
}, l) => /* @__PURE__ */ e.jsxs(R, { children: [
  /* @__PURE__ */ e.jsx(b, { animate: a ?? !0 }),
  /* @__PURE__ */ e.jsx("div", { className: C({
    side: t
  }), children: /* @__PURE__ */ e.jsx(x, { ref: l, "data-slot": "sheet-content", className: d(T({
    side: t,
    animate: a
  }), s), ...m, children: o }) })
] }));
B.displayName = x.displayName;
const z = c("tw-p-24 tw-relative tw-space-y-0", {
  variants: {
    headerAlignment: {
      center: "tw-flex tw-items-start tw-justify-center",
      left: "tw-flex tw-items-start"
    }
  },
  defaultVariants: {
    headerAlignment: "left"
  }
});
function q({
  className: t,
  children: a,
  showCloseButton: s,
  headerAlignment: o = "left",
  ...m
}) {
  return /* @__PURE__ */ e.jsxs("div", { "data-slot": "sheet-header", className: d("tw-flex tw-relative", z({
    headerAlignment: o
  }), t), ...m, children: [
    /* @__PURE__ */ e.jsx("div", { className: d("tw-flex tw-items-start tw-gap-12 tw-flex-1", {
      "tw-justify-start": o !== "center",
      "tw-justify-center tw-flex-col tw-items-center tw-text-center": o === "center"
    }), children: /* @__PURE__ */ e.jsx("div", { className: "tw-w-full", children: a }) }),
    s && /* @__PURE__ */ e.jsx(y, { headerAlignment: o })
  ] });
}
const E = ({
  className: t,
  showScrollBorder: a,
  children: s,
  ...o
}) => {
  const [m, l] = r.useState(!1), w = r.useRef(null), i = r.useCallback(() => {
    w.current && l(w.current.scrollTop > 0);
  }, []);
  return r.useEffect(() => {
    const n = w.current;
    if (n)
      return n.addEventListener("scroll", i), () => n.removeEventListener("scroll", i);
  }, [i]), /* @__PURE__ */ e.jsx("div", { ref: w, className: d("tw-flex-1 tw-overflow-auto tw-px-24 tw-overflow-y-auto", {
    "tw-border-b tw-border-gray-300": !!a,
    "tw-border-t tw-border-gray-300": !!a && m
  }, t), ...o, children: s });
};
E.displayName = "SheetBody";
function G({
  className: t,
  ...a
}) {
  return /* @__PURE__ */ e.jsx("div", { "data-slot": "sheet-footer", className: d("tw-mt-auto tw-flex tw-flex-col tw-gap-8 tw-p-16 md:tw-p-24", t), ...a });
}
const D = r.forwardRef(({
  className: t,
  ...a
}, s) => /* @__PURE__ */ e.jsx(p, { ref: s, "data-slot": "sheet-title", className: d("md:tw-headline-3-m tw-text-gray-900 tw-headline-2-m", t), ...a }));
D.displayName = p.displayName;
const F = r.forwardRef(({
  className: t,
  ...a
}, s) => /* @__PURE__ */ e.jsx(u, { ref: s, "data-slot": "sheet-description", className: d("tw-body-2 tw-text-gray-600 tw-mt-2", t), ...a }));
F.displayName = u.displayName;
export {
  H as Sheet,
  E as SheetBody,
  y as SheetClose,
  B as SheetContent,
  F as SheetDescription,
  G as SheetFooter,
  q as SheetHeader,
  R as SheetPortal,
  D as SheetTitle,
  W as SheetTrigger
};
//# sourceMappingURL=index.js.map
